module.exports = __webpack_public_path__ + "static/2021_headshot_round-fa99986ba5c0821ef5e3758d739a4a4c.png";